








import { Vue, Component } from 'vue-property-decorator';
import NewsList from '@/components/NewsList.vue';
import * as config from './config';
import { getNewslist } from '@/api/api.ts';
import { Popup } from 'vant';
type Target = 'detail' | 'success';
@Component({
  components: {
    NewsList,
  },
})
export default class Second extends Vue {
  option = config.OPTHINES;
  ListData = [];
  active = 0;
  Detail = {};
  modalVisible = false;
  target: Target = 'success';
}
